import { defineMessages } from 'react-intl';

export default defineMessages({
    provideVerificationInformation: {
        id: 'enrollment.components.additionalenrollment.Please provide the required verification information below for the policy or offer you want to link your account. Related policies will be added automatically.',
        defaultMessage: 'Please provide the required verification information below for the policy or offer you want to link your account. Related policies will be added automatically.',
    },
    relatedPoliciesAddedAutomatically: {
        id: 'enrollment.components.additionalenrollment.Related policies will be added automatically',
        defaultMessage: 'Related policies will be added automatically.',
    },
    completeFieldsToAccessPolicyInfo: {
        id: 'enrollment.components.additionalenrollment.Simply complete all fields for online access to your policy information',
        defaultMessage:
            'Simply complete all fields for online access to your policy information.',
    },
});
